import { CloudConvertUploadData } from '../types/interfaces';
import { validateFile } from '../utils/utils';
import { getApiHost } from '../utils/hosts';

export interface UploadResponse {
	filename: string;
	original_name: string;
}

export async function UploadDocument(token: string | null, file: FileList | File) {
	if (!token) {
		throw new Error('missing token for upload');
	}
	try {
		const formData = new FormData();
		if (file instanceof FileList) {
			formData.append('file', file[0]);
		} else {
			formData.append('file', file);
		}

		const isValidFile = validateFile(file);
		if (!isValidFile) return Promise.reject(new Error('Invalid file type'));

		const response = await fetch(`${getApiHost()}/v2/greenroom/upload-document`, {
			headers: {
				'bl-token': token,
			},
			method: 'POST',
			body: formData,
		});
		return await response.json();
	} catch (err) {
		return Promise.reject(new Error(`error uploading file: ${err}`));
	}
}

export function createInput(name: string, type: string, value: any): HTMLInputElement {
	const input = document.createElement('input');
	input.type = type;
	input.name = name;
	if (value instanceof FileList) {
		input.files = value;
	} else {
		input.value = value;
	}

	return input;
}

export function UploadConvert(cloudConvertUpload: CloudConvertUploadData, file: FileList) {
	return new Promise((resolve, reject) => {
		try {
			const form = document.createElement('form');
			const dummy = document.createElement('iframe');
			dummy.id = 'dummy';
			dummy.name = 'dummy';

			form.action = cloudConvertUpload.form.url;
			form.target = 'dummy';
			form.enctype = 'multipart/form-data';
			form.method = 'post';

			// The form parameters returned from createCloudConvertJob()
			// are dynamic so we build this upload form dynamically using
			// whatever parameters they gives us (these can and have changed in the past)
			const { parameters } = cloudConvertUpload.form;

			Object.keys(parameters).forEach((key) => {
				if (Object.prototype.hasOwnProperty.call(parameters, key)) {
					form.appendChild(createInput(key, 'hidden', parameters[key]));
				}
			});
			// File is always last
			form.appendChild(createInput('file', 'file', file));

			const submit = document.createElement('input');
			submit.type = 'submit';

			form.appendChild(submit);

			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			form.addEventListener('submit', (e: any) => {
				// console.log('submitting', e);
			});

			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			dummy.addEventListener('load', (e: any) => {
				// console.log(e);
				resolve(true);
			});

			form.style.display = 'none';
			document.body.appendChild(dummy);
			document.body.appendChild(form);

			form.submit();
		} catch (e) {
			reject(e);
		}
	});
}
